/* eslint-disable react/prop-types */

import "./CustomButton.css";
export const CustomButton = ({
    onClick,
    content,
    direction,
    size,
    weight,
    borderBottom,
    light,
    vAlignment
}) => {
    return (
        <div
            className="custom-button-container"
            style={{
                borderBottom: borderBottom ? "1px solid #fff" : "none",
            }}
        >
            <div
                className="custom-button"
                onClick={onClick}
                style={{
                    flexDirection: direction == "left" ? "row-reverse" : "row",
                    alignItems:vAlignment||'initial',
                }}
            >
                <p
                    style={{
                        fontSize: size || "16px",
                        fontWeight: weight || "300",
                        color: light ? "#000" : "#fff",
                    }}
                >
                    {content}
                </p>
                {direction === "left" ? (
                    <div
                        className="icon"
                        style={{
                            fontSize: size || "16px",
                            color: light ? "#000" : "#fff",
                        }}
                    >
                        &#8592;
                    </div>
                ) : (
                    <div
                        className="icon"
                        style={{
                            fontSize: size || "16px",
                            color: light ? "#000" : "#fff",
                        }}
                    >
                        &#8594;
                    </div>
                )}
            </div>
        </div>
    );
};
